<template>
    <div class="checkingManage">
        <!-- 搜索 -->
        <div class="key_top">
            <ul class="key_list">
                <li class="conditions_list_item" style="overflow:hidden">
                    <span>日期</span>
                    <span class="total_inp">
                        <el-date-picker v-model="search.date" @change="pageNumber=1,currentPage=1,queryManageList()" type="datetimerange" placeholder="请选择"></el-date-picker>
                    </span>
                </li>
                <li class="conditions_list_item">
                    <span>部门</span>
                    <el-input v-model="search.partmentName" @focus="departpopshow=!departpopshow" @clear="search.partmentName='',search.departmentId='',queryManageList()" placeholder="不限" clearable>
                    </el-input>
                    <div class="departpop" v-show="departpopshow">
                        <el-tree :default-expand-all="true" :data="departmentList" :props="defaultProps" @node-click="handleNodeClick">
                            <span class="custom-tree-node" slot-scope="{ node,data}">
                                <div>
                                    <img class="tree-icon" v-if="data.labelName=='区'" src="../../assets/icon/quyu.png" alt />
                                    <img class="tree-icon" v-if="data.labelName=='店'" src="../../assets/icon/dian.png" alt />
                                    <img class="tree-icon" v-if="data.labelName=='组'" src="../../assets/icon/zu.png" alt />
                                    <span>{{ data.name }}</span>
                                </div>
                            </span>
                        </el-tree>
                    </div>
                </li>
                <li class="conditions_list_item">
                    <span>员工</span>
<!--                    <el-input v-model="search.employeeName" @change="pageNumber=1,currentPage=1,queryManageList()" placeholder="请输入" clearable>-->
<!--                    </el-input>-->
                  <el-autocomplete class="select" popper-class="my-autocomplete" v-model="search.employeeName" :fetch-suggestions="querySearchAsync" placeholder="请选择" @select="handleSelect" clearable>
                    <template slot-scope="{ item }">
                      <div class="name" @select="handleSelect">{{ item.name }}</div>
                    </template>
                  </el-autocomplete>
                </li>
                <li class="conditions_list_item">
                    <span>状态</span>
                    <el-select v-model="search.status" @change="pageNumber=1,currentPage=1,queryManageList()" placeholder="不限" clearable>
                        <el-option v-for="(item,index) in statusList" :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </li>
            </ul>

            <div>
                <el-button type="primary" v-if="upDown=='UP'" @click="queryClockStatus">上班打卡</el-button>
                <el-button type="primary" v-if="upDown=='DOWN'" @click="queryClockStatus">下班打卡</el-button>
            </div>
        </div>
        <!-- 表格 -->
        <div class="key_list_wrap sales_list_wrap">
            <el-table :data="list" border style="width: 100%" :header-cell-style="setHeaderStyle" @row-click="rowColorclick" highlight-current-row v-if="liststatus=='two'">
                <el-table-column prop="date" label="日期"></el-table-column>
                <el-table-column prop="departmentName" label="部门"></el-table-column>
                <el-table-column prop="employeeName" label="员工"></el-table-column>
                <el-table-column prop="firstClockIn" label="上班打卡"></el-table-column>
                <el-table-column label="打卡状态">
                    <template slot-scope="scope">
                        <div @click="editClockStatus('firstClockInStatus',scope.row.firstClockInStatus,scope.row.id,scope.row.employeeId,scope.row.date,scope.row.whetherUpdate)">
                            <span :class="{rowColor:scope.row.id===isRowColor}" :style="scope.row.firstClockInStatus.indexOf('迟到')>=0?'color:#ff275f':scope.row.firstClockInStatus.indexOf('早退')>=0?'color:#ff35a2':scope.row.firstClockInStatus=='早退'?'color:#ff35a2':scope.row.firstClockInStatus=='缺卡'?'color:#ff6000':scope.row.firstClockInStatus=='请假'?'color:#22ca85':scope.row.secondClockInStatus=='外勤'?'color:#0096ff':scope.row.firstClockInStatus.indexOf('正常')>=0?'color:#5e75e6':'color:#22ca85'" style="margin:0 10px">{{ scope.row.firstClockInStatus }}</span>
                            <i v-if="scope.row.firstClockInStatus.indexOf('正常')<0 && scope.row.firstClockInStatus!='' &&scope.row.whetherUpdate" class="el-icon-edit"></i>
                            <!--              <i v-if="scope.row.firstClockInStatus!='' &&scope.row.whetherUpdate"-->
                            <!--                 class="el-icon-edit"></i>-->
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="firstClockInStatus" label="打卡状态"></el-table-column> -->
                <el-table-column prop="firstClockOut" label="下班打卡"></el-table-column>
                <el-table-column label="打卡状态">
                    <template slot-scope="scope">
                        <div @click="editClockStatus('firstClockOutStatus',scope.row.firstClockOutStatus,scope.row.id,scope.row.employeeId,scope.row.date,scope.row.whetherUpdate)">
                            <span :class="{rowColor:scope.row.id===isRowColor}" :style="scope.row.firstClockOutStatus.indexOf('迟到')>=0||scope.row.firstClockOutStatus.indexOf('早退')>=0?'color:#ff35a2':scope.row.firstClockOutStatus=='早退'?'color:#ff35a2':scope.row.firstClockOutStatus=='缺卡'?'color:#ff6000':scope.row.firstClockOutStatus=='请假'?'color:#22ca85':scope.row.firstClockOutStatus=='外勤'?'color:#0096ff':scope.row.firstClockOutStatus.indexOf('正常')>=0?'color:#5e75e6':'color:#22ca85'" style="margin:0 10px">{{ scope.row.firstClockOutStatus }}</span>
                            <i v-if="scope.row.firstClockOutStatus.indexOf('正常')<0  && scope.row.firstClockOutStatus!='' &&scope.row.whetherUpdate" class="el-icon-edit"></i>
                            <!--              <i v-if=" scope.row.firstClockOutStatus!='' &&scope.row.whetherUpdate"-->
                            <!--                 class="el-icon-edit"></i>-->
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="overTimeHours" label="加班时长(小时)"></el-table-column>
            </el-table>
            <el-table :data="list" border style="width: 100%" :header-cell-style="setHeaderStyle" @row-click="rowColorclick" highlight-current-row v-if="liststatus=='four'">
                <el-table-column prop="date" label="日期"></el-table-column>
                <el-table-column prop="departmentName" label="部门"></el-table-column>
                <el-table-column prop="employeeName" label="员工"></el-table-column>
                <el-table-column prop="firstClockIn" label="上班打卡"></el-table-column>
                <el-table-column label="打卡状态">
                    <template slot-scope="scope">
                        <div @click="editClockStatus('firstClockInStatus',scope.row.firstClockInStatus,scope.row.id,scope.row.employeeId,scope.row.date,scope.row.whetherUpdate)">
                            <span :class="{rowColor:scope.row.id===isRowColor}" :style="scope.row.firstClockInStatus.indexOf('迟到')>=0?'color:#ff275f':scope.row.firstClockInStatus.indexOf('早退')>=0?'color:#ff35a2':scope.row.firstClockInStatus=='早退'?'color:#ff35a2':scope.row.firstClockInStatus=='缺卡'?'color:#ff6000':scope.row.firstClockInStatus=='请假'?'color:#22ca85':scope.row.firstClockInStatus=='外勤'?'color:#0096ff':scope.row.firstClockInStatus.indexOf('正常')>=0?'color:#5e75e6':'color:#22ca85'" style="margin:0 10px">{{ scope.row.firstClockInStatus }}</span>
                            <i v-if="scope.row.firstClockInStatus.indexOf('正常')<0 && scope.row.firstClockInStatus!='' &&scope.row.whetherUpdate" class="el-icon-edit"></i>
                            <!--              <i v-if="scope.row.firstClockInStatus!='' &&scope.row.whetherUpdate"-->
                            <!--                 class="el-icon-edit"></i>-->
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="firstClockInStatus" label="打卡状态"></el-table-column> -->
                <el-table-column prop="firstClockOut" label="下班打卡"></el-table-column>
                <el-table-column label="打卡状态">
                    <template slot-scope="scope">
                        <div @click="editClockStatus('firstClockOutStatus',scope.row.firstClockOutStatus,scope.row.id,scope.row.employeeId,scope.row.date,scope.row.whetherUpdate)">
                            <span :class="{rowColor:scope.row.id===isRowColor}" :style="scope.row.firstClockOutStatus.indexOf('迟到')>=0||scope.row.firstClockOutStatus.indexOf('早退')>=0?'color:#ff35a2':scope.row.firstClockOutStatus=='早退'?'color:#ff35a2':scope.row.firstClockOutStatus=='缺卡'?'color:#ff6000':scope.row.firstClockOutStatus=='请假'?'color:#22ca85':scope.row.firstClockOutStatus=='外勤'?'color:#0096ff':scope.row.firstClockOutStatus.indexOf('正常')>=0?'color:#5e75e6':'color:#22ca85'" style="margin:0 10px">{{ scope.row.firstClockOutStatus }}</span>
                            <i v-if="scope.row.firstClockOutStatus.indexOf('正常')<0 && scope.row.firstClockOutStatus!='' &&scope.row.whetherUpdate" class="el-icon-edit"></i>
                            <!--              <i v-if="scope.row.firstClockOutStatus!='' &&scope.row.whetherUpdate"-->
                            <!--                 class="el-icon-edit"></i>-->
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="firstClockOutStatus" label="打卡状态"></el-table-column> -->
                <el-table-column prop="secondClockIn" label="二次上班打卡"></el-table-column>
                <el-table-column label="打卡状态">
                    <template slot-scope="scope">
                        <div @click="editClockStatus('secondClockInStatus',scope.row.secondClockInStatus,scope.row.id,scope.row.employeeId,scope.row.date,scope.row.whetherUpdate)">
                            <span :class="{rowColor:scope.row.id===isRowColor}" :style="scope.row.secondClockInStatus.indexOf('迟到')>=0||scope.row.secondClockInStatus.indexOf('早退')>=0?'color:#ff35a2':scope.row.secondClockInStatus=='早退'?'color:#ff35a2':scope.row.secondClockInStatus=='缺卡'?'color:#ff6000':scope.row.secondClockInStatus=='请假'?'color:#22ca85':scope.row.secondClockInStatus=='外勤'?'color:#0096ff':scope.row.secondClockInStatus.indexOf('正常')>=0?'color:#5e75e6':'color:#22ca85'" style="margin:0 10px">{{ scope.row.secondClockInStatus }}</span>
                            <i v-if="scope.row.secondClockInStatus.indexOf('正常')<0 && scope.row.secondClockInStatus!='' &&scope.row.whetherUpdate" class="el-icon-edit"></i>
                            <!--              <i v-if="scope.row.secondClockInStatus!='' &&scope.row.whetherUpdate"-->
                            <!--                 class="el-icon-edit"></i>-->
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="secondClockInStatus" label="打卡状态"></el-table-column> -->
                <el-table-column prop="secondClockOut" label="二次下班打卡"></el-table-column>
                <el-table-column label="打卡状态">
                    <template slot-scope="scope">
                        <div @click="editClockStatus('secondClockOutStatus',scope.row.secondClockOutStatus,scope.row.id,scope.row.employeeId,scope.row.date,scope.row.whetherUpdate)">
                            <span :class="{rowColor:scope.row.id===isRowColor}" :style="scope.row.secondClockOutStatus.indexOf('迟到')>=0||scope.row.secondClockOutStatus.indexOf('早退')>=0?'color:#ff35a2':scope.row.secondClockOutStatus=='早退'?'color:#ff35a2':scope.row.secondClockOutStatus=='缺卡'?'color:#ff6000':scope.row.secondClockOutStatus=='请假'?'color:#22ca85':scope.row.secondClockOutStatus=='外勤'?'color:#0096ff':scope.row.secondClockOutStatus.indexOf('正常')>=0?'color:#5e75e6':'color:#22ca85'" style="margin:0 10px">{{ scope.row.secondClockOutStatus }}</span>
                            <i v-if="scope.row.secondClockOutStatus.indexOf('正常')<0 && scope.row.secondClockOutStatus!='' &&scope.row.whetherUpdate" class="el-icon-edit"></i>
                            <!--              <i v-if="scope.row.secondClockOutStatus!='' &&scope.row.whetherUpdate"-->
                            <!--                 class="el-icon-edit"></i>-->
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="secondClockOutStatus" label="打卡状态"></el-table-column> -->
                <el-table-column prop="overTimeHours" label="加班时长(小时)"></el-table-column>
            </el-table>
            <div class="footer_page">
                <div>
                    <el-button type="primary" v-if="permisShow('考勤统计')" @click="goto">考勤统计</el-button>
                </div>
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 20, 30, 40]" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
            </div>
        </div>

        <el-dialog :title="title" :visible.sync="dialogVisible" width="380px">
            <div class="time" :style="title.indexOf('迟到')>=0||title.indexOf('提前')>=0?'color:red':''">
                {{time}}
                <el-button class="submint" @click="dialogVisible=false" type="primary">我知道啦</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible1" width="380px">
            <div class="msg">{{title}}</div>
            <div class="footer">
                <el-button class="submint1" style="background: #999999;border:1px solid  #999999" @click="dialogVisible1=false" type="primary">取消</el-button>
                <el-button class="submint1" type="primary" v-points @click="addClock">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible2" width="380px">
            <div class="msg">{{title}}</div>
            <div class="footer">
                <el-button class="submint1" type="primary" @click="dialogVisible2=false">我知道啦</el-button>
            </div>
        </el-dialog>
        <el-dialog title="考勤状态更改" :visible.sync="dialogVisible3" width="380px">
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="状态:">
                    <el-select v-model="changeStatus" placeholder="不限" clearable disabled>
                        <el-option v-for="(item,index) in changestatusList" :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注:">
                    <el-input type="textarea" :rows="4" v-model="form.remarks"></el-input>
                </el-form-item>
            </el-form>
            <div class="footer">
                <el-button class="submint1" style="background: #999999;border:1px solid  #999999" @click="dialogVisible3=false" type="primary">取消</el-button>
                <el-button class="submint1" type="primary" v-points @click="updateAttendance">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { departmentFind, employeeQuery } from "@/api/manageCenter";
import {
    queryManageList,
    addClock,
    queryClockStatus,
    updateAttendance
} from "@/api/checkingIn";
import { currentHourTime } from "@/vue/util/tool";
import { getRouterLevel } from "@/vue/util/tool";
export default {
    // name: "考勤管理",
    name: "/checkingManage",
    data() {
        let permisList = JSON.parse(sessionStorage.getItem("permisList"));
        return {
            permisList,
            isRowColor: "",
            title: "",
            remark: "",
            list: [], //考勤管理列表
            liststatus: "two",
            time: "", //当前时间
            total: 0, //每页条数
            currentPage: 1, //页数
            pageNumber: 1,
            pageSize: 20,
            dialogVisible: false, //导出弹框显示隐藏
            dialogVisible1: false,
            dialogVisible2: false,
            dialogVisible3: false,
            form: {
                id: "",
                employeeId: "",
                oldStatus: "",
                remarks: "",
                date: ""
            },
            changeStatus: 'NORMAL',
            statusOld: '',
            changeStatusType: '',
            departpopshow: false,
            upDown: "",
            status: false,
            departmentList: [],
            statusList: [
                {
                    label: "正常",
                    value: "NORMAL"
                },
                {
                    label: "迟到",
                    value: "LATE"
                },
                {
                    label: "早退",
                    value: "LEAVE_EARLY"
                },
                {
                    label: "加班",
                    value: "ADD_WORK"
                },
                {
                    label: "外勤",
                    value: "FIELD"
                },
                {
                    label: "请假",
                    value: "HOLIDAY"
                },
                {
                    label: "缺卡",
                    value: "MISS"
                },{
                    label: "正常(外勤)",
                    value: "PERSONNEL_NORMAL"
                },{
                    label: "早退(外勤)",
                    value: "PERSONNEL_EARLY"
                },{
                    label: "迟到(外勤)",
                    value: "PERSONNEL_LATE"
                },
            ],
            changestatusList: [
                {
                    label: "正常",
                    value: "NORMAL"
                },
                {
                    label: "迟到",
                    value: "LATE"
                },
                {
                    label: "早退",
                    value: "LEAVE_EARLY"
                },
                {
                    label: "外勤",
                    value: "FIELD"
                },
                {
                    label: "请假",
                    value: "HOLIDAY"
                },
                {
                    label: "缺卡",
                    value: "MISS"
                }
            ],
            defaultProps: {
                children: "child"
            },
            //搜索
            search: {
                date: [], //日期
                departmentId: "", //部门id
                partmentName: "",
                employeeName: "", //员工姓名
                employeeId: "", //员工姓名
                status: "" //打卡状态
            }
        };
    },
    mounted() {
        this.queryManageList();
        this.getdepartmentFindAll();
        this.queryClockStatus1();
        this.isRowColor = "";
    },
    activated() {
        this.queryManageList();
        this.getdepartmentFindAll();
        this.queryClockStatus1();
        this.isRowColor = "";
    },

    methods: {
        permisShow(data) {
            // 权限配置
            let result = this.permisList.indexOf(data);
            if (result >= 0) {
                return true;
            } else {
                return false;
            }
        },
        rowColorclick(row) {
            this.isRowColor = row.id;
        },
        queryManageList() {
            // 考勤管理列表查询
            this.isRowColor = "";
            let params = Object.assign({}, this.search);

            params["page.pageNumber"] =
                this.pageNumber * this.pageSize - this.pageSize;
            params["page.pageSize"] = this.pageSize;
            let result = this.permisShow("考勤管理查看");
            if (result) {
                params.permissionLevel = getRouterLevel("考勤管理查看");
            } else {
                params.permissionLevel = 6;
            }
            let result1 = this.permisShow("编辑异常状态");
            if (result1) {
                params.updatePermissionLevel = getRouterLevel("编辑异常状态");
            } else {
                params.updatePermissionLevel = 6;
            }
            this.$post(queryManageList, params).then(res => {
                if (res.success) {
                    this.list = res.data.fourTimes;
                    if (this.list && this.list.length != 0) {
                        this.liststatus = this.list[0].status;
                    }
                    this.total = res.total;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            });
        },

        //分页
        handleCurrentChange(val) {
            this.pageNumber = val;
            this.queryManageList();
        },
        handleSizeChange(val) {
            this.pageNumber = 1;
            this.pageSize = val;
            this.queryManageList();
        },
        getdepartmentFindAll() {
            this.$post(departmentFind).then(res => {
                if (res.success) {
                    this.departmentList = res.data;
                }
            });
        },

        handleNodeClick(node, data) {
            (this.pageNumber = 1), (this.currentPage = 1), (this.search.partmentName = node.name);
            this.search.departmentId = node.id;
            this.departpopshow = false;
            this.queryManageList();
            this.employeesData=[]
          // this.search.employeeId ='';
          // this.search.employeeName = '';
        },
        querySearchAsync(queryString, cb) {
          this.employeesList=[]
          let status = ''
          if (!queryString){
            status = 'ENABLE'
          }
          let params = {
            name: queryString,
            status:status,
            departmentId:this.search.departmentId
          };

          this.$post(employeeQuery, params).then(res => {
            if (res.success) {
              if (!queryString){
                if (res.data.length<=0){
                  this.$message.error('该部门下暂无人员！');
                }
              }
              this.employeesData = res.data;
              let restaurants = this.employeesData;
              cb(restaurants);
              if (!this.search.employeeName) {
                this.search.employeeId = '';
                this.handleCurrentChange(1);
              }

            } else {
            }
          });
        },
        handleSelect(item) {
          console.log(123, item)
          this.search.employeeId = item.id;
          this.search.employeeName = item.name;
          this.handleCurrentChange(1);
          //cosole.log(this.contractMsg.signer)
        },
        addClock() {
            // 打卡

            this.$post(addClock).then(res => {
                if (res.success) {
                    // this.$message.success(res.msg)
                    this.dialogVisible1 = false;
                    if (this.remark.indexOf("提前") >= 0) {
                        this.title = "提前下班！";
                        this.dialogVisible = true;
                    }
                    this.queryManageList();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        queryClockStatus() {
            // 打卡查询是否可以打卡
            let params = {
                ipAddress: sessionStorage.getItem("ipAddress")
            };
            this.$post(queryClockStatus, params).then(res => {
                if (res.success) {
                    let curtime = res.timestamp.split("T")[1];
                    this.time = curtime.split(":")[0] + ":" + curtime.split(":")[1];
                    this.status = res.data.status;
                    this.title = res.data.remark;
                    if (res.data.status) {
                        this.addClock();
                        this.dialogVisible = true;
                    } else {
                        this.dialogVisible1 = true;
                        this.remark = res.data.remark;
                    }
                }
            });
        },

        editClockStatus(name, status, id, employeeId, date, whetherUpdate) {
            // 修改打卡状态
            if (status == "") {
                return;
            }
            this.changeStatusType = name;
            // this.changestatusList.map((item,index)=>{
            //   if (status===item.label){
            //     this.changeStatus = item.value;
            //     this.statusOld = item.value;
            //   }
            // });
            console.log(status)
            // if (status.indexOf("正常") < 0 && whetherUpdate) {
            if (whetherUpdate) {
                this.form = {
                    id: id,
                    employeeId: employeeId,
                    oldStatus: status,
                    remarks: "",
                    date: date
                };
                if (name == "firstClockInStatus") {
                    this.form.firstClockInStatus = this.changeStatus;
                } else if (name == "firstClockOutStatus") {
                    this.form.firstClockOutStatus = this.changeStatus;
                } else if (name == "secondClockInStatus") {
                    this.form.secondClockInStatus = this.changeStatus;
                } else if (name == "secondClockOutStatus") {
                    this.form.secondClockOutStatus = this.changeStatus;
                }
                this.dialogVisible3 = true;
            }
        },

        updateAttendance() {
            let params = Object.assign({}, this.form);
            if (this.changeStatusType == "firstClockInStatus") {
                params.firstClockInStatus = this.changeStatus;
            } else if (this.changeStatusType == "firstClockOutStatus") {
                params.firstClockOutStatus = this.changeStatus;
            } else if (this.changeStatusType == "secondClockInStatus") {
                params.secondClockInStatus = this.changeStatus;
            } else if (this.changeStatusType == "secondClockOutStatus") {
                params.secondClockOutStatus = this.changeStatus;
            }
            if (this.statusOld === this.changeStatus) {
                this.$message.error('状态无变化，无需更改')
            } else {
                this.$post(updateAttendance, params).then(res => {
                    if (res.success) {
                        this.$message.success(res.msg);
                        this.dialogVisible3 = false;
                        this.queryManageList();
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            }

        },

        queryClockStatus1() {
            // 打卡查询上班还是下班
            if (
                window.navigator.userAgent.match(
                    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
                )
            ) {
                this.$message.error("该系统不允许手机登录");
                return false; // 移动端
            }
            let params = {
                ipAddress: sessionStorage.getItem("ipAddress")
            };
            this.$post(queryClockStatus, params).then(res => {
                if (res.success) {
                    this.upDown = res.data.upDown;
                } else {
                    this.title = res.msg;
                    this.dialogVisible2 = true;
                }
            });
        },
        //表单头部颜色
        setHeaderStyle() {
            return "background-color: #F2F4FF";
        },
        goto() {
            this.$router.push("attendanceStatistics");
        }
    }
};
</script>
<style lang="less">
.checkingManage {
    .key_list {
        display: flex;
        .el-input__icon {
            line-height: 30px;
        }
        .conditions_list_item {
            padding: 0 0 0 10px;
            display: flex;
            align-items: center;
            margin-right: 20px;
            position: relative;
            cursor: pointer;
            .departpop {
                width: 170px;
                position: absolute;
                left: 0;
                top: 41px;
                z-index: 10;
                border: 1px solid #eee;
                .tree-item {
                    display: flex;
                    align-items: center;
                    img {
                        padding-right: 10px;
                    }
                }
            }
            > span {
                line-height: 20px;
                font-size: 12px;
                color: #666;
                padding: 0;
                padding-right: 10px;
            }
            .el-input {
                width: 160px;
                height: 30px;
                .el-input-group__append,
                .el-input-group__prepend {
                    padding: 0 10px;
                    border: 1px solid #dbdbdb;
                }

                .el-input__inner {
                    height: 30px;
                    border: 1px solid #dbdbdb;
                }

                .icon-icon_sousuo {
                    color: white;
                }
            }
            .el-select {
                margin-left: 10px;
                .el-input {
                    width: 100px;
                    .el-input__inner {
                        width: 100px;
                        height: 30px;
                        border: 1px solid #dbdbdb;
                        color: black;
                        padding: 0 5px;
                    }
                    .el-input__icon {
                        line-height: 30px;
                    }
                }
            }
            .total_inp {
                border: none;
                display: flex;
                align-items: center;
                height: 30px;
                width: 220px;
                padding-right: 0;
                .el-date-editor {
                    border: 1px solid #dbdbdb;
                    height: 30px;
                    width: 220px;
                    .el-input__icon {
                        line-height: 25px !important;
                    }
                    .el-range-separator {
                        line-height: 25px;
                    }
                }
            }
        }
    }
    .el-button--primary {
        width: 120px;
        height: 30px;
        padding: 0;
        background: #5e75e6;
        border-color: #5e75e6;
    }
    .el-dialog {
        .el-dialog__header {
            text-align: center;
            padding-top: 40px;
            padding-bottom: 0;
            .el-dialog__title {
                font-size: 20px;
                color: #333333;
            }
        }
        .el-dialog__body {
            .time {
                padding-top: 70px;
                text-align: center;
                font-size: 80px;
                color: #4790f2;
                font-family: "IMPACT";
                .submint {
                    width: 260px;
                    height: 50px;
                    margin: 100px 0 20px 0;
                    display: inline-block;
                    background: rgba(94, 117, 230, 1);
                    border-radius: 4px;
                    text-align: center;
                    font-size: 18px;
                    color: #fff;
                    line-height: 50px;
                }
            }
            .msg {
                font-size: 14px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                text-align: center;
                padding: 20px 0 50px 0;
            }
            .el-form {
                padding-top: 20px;
                .el-textarea__inner {
                    width: 90%;
                }
            }
            .footer {
                height: 80px;
                background: #f5f5f5;
                padding-right: 40px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                .submint1 {
                    // width: 80px;
                    height: 40px;
                    background: rgba(94, 117, 230, 1);
                    border-radius: 4px;
                    text-align: center;
                    font-size: 18px;
                    color: #fff;
                    line-height: 40px;
                }
            }
        }
    }
}
</style>
<style lang='less' scoped>
.checkingManage {
    height: 100%;
    .el-table .cell,
    .el-table th div,
    .el-table--border td:first-child .cell,
    .el-table--border th:first-child .cell {
        text-align: center;
    }

    .key_top {
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        background: #fff;

        .add_btn {
            width: 100px;
            height: 30px;
            background: #5e75e6;
            color: white;
            outline: none;
            border: none;
        }
    }

    .key_list_wrap {
        // .el-dialog {
        //     width: 600px;

        //     .el-dialog__title {
        //         color: #5e75e6;
        //         font-size: 20px;
        //     }

        //     .el-dialog__close {
        //         font-size: 26px;
        //     }

        //     .el-dialog__body {
        //         padding-left: 0;
        //         padding-right: 0;
        //         padding-bottom: 0;
        //     }
        // }

        .footer_page {
            position: relative;
            margin-top: 20px;
            padding-left: 100px;
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;

            .el-pagination.is-background .el-pager li:not(.disabled).active {
                background-color: #5e75e6;
            }

            .el-pagination.is-background .btn-next,
            .el-pagination.is-background .btn-prev,
            .el-pagination.is-background .el-pager li {
                border: 1px solid #ccc;
                background: white;
            }
        }
    }
}
</style>